module.exports = __webpack_public_path__ + "img/feature03.6fd3f4f.jpg";